// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		suggestionMobileStyle: 'style2',
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

	InstantSearchResultItemProduct.prototype.compileSuggestionProductPrice = function() {
		// If the multi-currency feature is enabled, update the product price
		this.prepareSuggestionProductPriceData();
		// Check on sale
		var onSale = this.data.compare_at_price_min > this.data.price_min;
		// Format price
		var price = Utils.formatMoney(this.data.price_min);
		var compareAtPrice = '';
		if (this.data && this.data.compare_at_price_min) {
			compareAtPrice = Utils.formatMoney(this.data.compare_at_price_min);
			if (Settings.getSettingValue('search.removePriceDecimal')) {
				price = Utils.removeDecimal(price);
				compareAtPrice = Utils.removeDecimal(compareAtPrice);
			}
		}

		// Build Price
		var result = '';
		if (Settings.getSettingValue('search.showSuggestionProductPrice')) {
			if (onSale && Settings.getSettingValue('search.showSuggestionProductSalePrice')) {
				result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE_SALE);
			} else {
				result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE);
			}
		}

    var results = (!this.data.tags.includes('Hide Price')) ? result : '';
		return results
			.replace(/{{regularPrice}}/g, price)
			.replace(/{{compareAtPrice}}/g, compareAtPrice);
	}

	SearchInput.prototype.afterRender = function () {
		var self = this;
		this.$element.on('keydown', function (event) {
			if (event.code === 'Enter' || event.key === 'Enter' || event.which === 13) {
				event.preventDefault;
				self.$searchForm[0].submit();
			}
		});
	}

	jQ(document).on('click', '.search-modal__form .search__button, .search-page-header .search__submit', function(event) {
		event.preventDefault();
		var params = jQ(event.target).closest('form').serialize();
		window.location = '/search?' + params;
	});
})();